import React, { useEffect, useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import HistoricalSignalsList from "./HistoricalSignalsList";
import MissingReturnsTickers from "../Popup/MissingReturnsTickers";

const HistoricalSignalsDisplay = ({
  strategies,
  strategyValObj,
  strategyVal,
  onDownload,
  hasData,
  historicalSignalSet,
  isFetchingHistoricalSignals,
}) => {
  const [showMissingTickers, setShowMissingTickers] = useState(false);

  useEffect(() => {
    if (historicalSignalSet?.missingReturnsTickers?.length) {
      setShowMissingTickers(true);
    }
  }, [historicalSignalSet?.missingReturnsTickers]);

  if (!hasData && !isFetchingHistoricalSignals) {
    return null;
  }
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>  
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: "text.primary",
                fontSize: "1.1rem",
              }}
            >
              Historical Signals
            </Typography>
            <Box sx={{ display: "flex", gap: "8px" }}>
              <button
                onClick={onDownload}
                disabled={!hasData}
                style={{
                  backgroundColor: !hasData ? "#cccccc" : "#4caf50",
                  color: !hasData ? "#666666" : "white",
                  fontWeight: 500,
                  textTransform: "none",
                  border: "none",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  cursor: !hasData ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontFamily: "inherit",
                  minHeight: "36px",
                  boxShadow: !hasData
                    ? "none"
                    : "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                  opacity: !hasData ? 0.6 : 1,
                }}
                onMouseEnter={(e) => {
                  if (!hasData) return;
                  e.target.style.backgroundColor = "#388e3c";
                }}
                onMouseLeave={(e) => {
                  if (!hasData) return;
                  e.target.style.backgroundColor = "#4caf50";
                }}
              >
                <DownloadIcon style={{ fontSize: "20px" }} />
                Download All
              </button>
            </Box>
          </Box>
          <HistoricalSignalsList
            strategies={strategies}
            strategyValObj={strategyValObj}
            strategyVal={strategyVal}
          />
        </Grid>
      </Grid>
      <MissingReturnsTickers
        open={showMissingTickers}
        onClose={() => setShowMissingTickers(false)}
        missingReturnsTickers={historicalSignalSet?.missingReturnsTickers}
      />
    </Box>
  );
};

export default HistoricalSignalsDisplay;
